<template>
  <div class="complaint-shop-detail" v-loading="loading">
    <template v-if="pageStatus">
      <page-title title="投诉状态">
        <ul class="info-form" style="margin-bottom:16px">
          <li class="form-item">
            <span class="form-item-label">处理状态：</span>
            <div class="form-item-content">
              <template v-if="handleState === HANDLESTATUS.HANDLED">
                <i class="el-icon-circle el-icon-circle-check" style="background-color:#888888"></i>
                <span style="color:#888888">平台已处理</span>
              </template>
              <template v-else>
                <i class="el-icon-circle el-icon-time" style="background-color:#005bff"></i>
                <span style="color:#005bff">待平台处理</span>
              </template>
              <!-- <i class="el-icon-circle el-icon-remove-outline" style="background-color:#00bd83"></i>
              <span style="color:#00bd83">平台处理中</span>
              <i
                class="el-icon-circle el-icon-sort-down"
                style="background-color:#dadde0;transform:rotate(-90deg);"
              ></i>
              <span style="color:#dadde0;">买家已撤销</span>
              <i class="el-icon-circle el-icon-circle-close" style="background-color:#ff5753"></i>
              <span style="color:#ff5753">平台已驳回</span> -->
            </div>
          </li>
        </ul>
      </page-title>
      <div class="flex-row">
        <page-title title="店铺信息" class="complaint-shop-panel">
          <ul class="info-form" style="min-width:310px;">
            <li class="form-item">
              <span class="form-item-label">店铺名称：</span>
              <div class="form-item-content">
                <i class="el-icon-circle el-icon-s-shop" style="background-color:#005bff"></i>
                <span>{{ spu.store.name }}</span>
              </div>
            </li>
            <li class="form-item">
              <span class="form-item-label">联系方式：</span>
              <div class="form-item-content">
                {{ spu.store.customerPhone }}
              </div>
            </li>
          </ul>
        </page-title>
        <page-title title="买家信息" class="complaint-shop-panel">
          <ul class="info-form" style="min-width:310px;">
            <li class="form-item">
              <span class="form-item-label">买家昵称：</span>
              <div class="form-item-content">
                <i class="el-icon-circle el-icon-user-solid" style="background-color:#00bd83"></i>
                <span>{{ userInfo.nickname }}</span>
              </div>
            </li>
            <li class="form-item">
              <span class="form-item-label">联系方式：</span>
              <div class="form-item-content">
                {{ userInfo.mobile || '- -' }}
              </div>
            </li>
          </ul>
        </page-title>
        <page-title title="投诉信息" class="complaint-shop-panel" style="flex:1;">
          <ul class="info-form">
            <li class="form-item">
              <span class="form-item-label">投诉编号：</span>
              <div class="form-item-content">
                {{ comData.complaintNo }}
              </div>
            </li>
            <li class="form-item">
              <span class="form-item-label">投诉类型：</span>
              <div class="form-item-content" style="max-width:220px">
                {{ COMPLAINT_TYPE_ZH[comData.type] }}
              </div>
              <span class="form-item-label">投诉时间：</span>
              <div class="form-item-content">
                {{ comData.applyTime }}
              </div>
            </li>
            <li class="form-item">
              <span class="form-item-label">投诉说明：</span>
              <div class="form-item-content">
                {{ comData.reason }}
              </div>
            </li>
            <li class="form-item">
              <span class="form-item-label">凭证：</span>
              <div class="form-item-content">
                <img v-for="img in comData.mediaItems" v-pic="img.location" :key="img.id" v-preview />
              </div>
            </li>
          </ul>
        </page-title>
      </div>
      <page-title title="商品信息">
        <el-table :data="[{}]" style="width: 100%" :header-cell-style="{ backgroundColor: `#f7f7f7` }" border>
          <el-table-column label="商品信息" width="1000">
            <div style="display:flex;">
              <img v-pic="spu.images[0].location" alt="" />
              <div class="table-inner-info">
                <span>{{ spu.name }}</span>
                <p style="max-width:582px">
                  <template v-for="s in goods_specifications"> {{ s.name }}: {{ s.value }},</template>
                </p>
              </div>
            </div>
          </el-table-column>
          <el-table-column label="单价" align="center">
            <span>￥{{ spu.price.toFixed(2) }}</span>
          </el-table-column>
        </el-table>
      </page-title>
      <page-title title="处理信息">
        <ul class="process-list">
          <process-item
            v-if="handleState === HANDLESTATUS.HANDLED"
            :name="'平台'"
            :time="comData.processingTime"
            :des="`平台已处理，处理结果：${comData.result || '- -'}`"
            :avatar="``"
            oauth
          />
          <process-item
            :name="userInfo.nickname || '买家昵称'"
            :time="comData.applyTime"
            :des="`发起了投诉申请，投诉类型：${COMPLAINT_TYPE_ZH[comData.type]}。`"
            :avatar="userInfo.avatar"
            :imgs="comData.mediaItems"
            oauth
          />
        </ul>
      </page-title>
      <page-title title="处理">
        <div class="form-item">
          <span class="form-item-label" style="width:auto;">备注（仅工作人员可见）：</span>
          <div class="form-item-content">
            <el-input
              :disabled="comData.state === 'FINISH'"
              v-model="remarks"
              placeholder="备注"
              type="textarea"
              resize="none"
              rows="5"
            ></el-input>
          </div>
        </div>
        <div class="btn-grp" v-if="comData.state === 'LAUNCH'">
          <el-button @click="dialogVisible = true">已处理</el-button>
          <el-button @click="$router.replace('/complaint?type=1')">关闭</el-button>
        </div>
      </page-title>
    </template>
    <div v-if="!loading && !pageStatus" class="no-content-area">
      页面加载失败，请刷新试试~
    </div>
    <el-dialog title="已处理" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false">
      <el-form label-width="120px">
        <el-form-item label="处理结果：">
          <el-input v-model="handleResult" placeholder="请输入" type="textarea" rows="7" resize="none"></el-input>
        </el-form-item>
      </el-form>
      <div class="btn-grp" style="padding:0;" slot="footer">
        <el-button @click="handleCom">确定</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PageTitle from '@/components/pageTitle';
import ProcessItem from './components/processItem';
import { getSpuComplaintById, handleSpuComplaintById } from '@/api/req';
import { HANDLE_STATE, COMPLAINT_TYPE_ZH } from './_eum';

export default {
  components: { PageTitle, ProcessItem },
  name: 'complaintShopDetail',
  data() {
    return {
      pageStatus: false,
      loading: true,
      comData: {},
      dialogVisible: false,
      remarks: '',
      handleResult: ''
    };
  },
  computed: {
    HANDLESTATUS: () => HANDLE_STATE,
    COMPLAINT_TYPE_ZH: () => COMPLAINT_TYPE_ZH,
    spuId() {
      return this.$route.params.id;
    },
    handleState() {
      return this.comData.handleState;
    },
    spu() {
      return this.comData.spu || {};
    },
    goods_specifications() {
      return this.comData?.spu?.skus?.[0]?.specifications || [];
    },
    userInfo() {
      return this.comData.userInfoModelVO || '';
    },
    sellerInfo() {
      return this.comData.sellerUserInfoModelVO || '';
    }
  },
  methods: {
    getData() {
      this.loading = true;
      this.pageStatus = false;
      this.$ajax
        .get(getSpuComplaintById(this.spuId))
        .then(({ data }) => {
          this.loading = false;
          this.pageStatus = true;
          this.comData = Object.freeze(data);
          this.remarks = data.remarks;
        })
        .catch(err => {
          console.log(err.data);
          this.loading = false;
          this.pageStatus = false;
        });
    },
    handleCom() {
      const { handleResult: result, remarks } = this;
      if (!result) {
        this.$message.info('请填写处理结果！');
        return;
      }
      this.$ajax
        .put(handleSpuComplaintById(this.spuId), { result, remarks })
        .then(res => {
          this.getData();
          this.$message.success('处理成功');
          this.dialogVisible = false;
        })
        .catch(err => {
          this.$message.info('处理失败');
        });
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="scss">
.complaint-shop-detail {
  min-height: 800px;
  .flex-row {
    display: flex;
    & > .complaint-shop-panel {
      &:not(:last-of-type) {
        margin-right: 16px;
      }
    }
  }
  .info-form {
    // padding: 24px 20px;
    background-color: white;
    border-radius: 4px;
  }
  .form-item {
    margin-top: 20px;
    display: flex;
    align-items: center;
    &:first-child {
      margin-top: 0;
    }
    &-label {
      width: 60px;
      height: 20px;
      font-size: 12px;
      font-weight: 500;
      color: #8998a0;
      line-height: 20px;
      margin-right: 6px;
      align-self: flex-start;
    }
    &-content {
      flex: 1;
      font-size: 14px;
      font-weight: 400;
      color: #040b28;
      line-height: 20px;
      max-width: 960px;
      img {
        height: 78px;
        width: 78px;
        border-radius: 4px;
        font-size: 0;
        vertical-align: bottom;
        margin-right: 8px;
        object-fit: contain;
      }
      .el-icon-circle {
        margin-right: 8px;
        color: #fff;
        vertical-align: middle;
      }
    }
  }
  .btn-grp {
    padding: 30px 0;
    background-color: white;
    border-radius: 4px;
    .el-button {
      padding: 13px 30px;
      border-color: #002b9c;
      color: #002b9c;
      &:not(.is-disabled):hover {
        background-color: #002b9c;
        color: white;
      }
    }
    .is-disabled {
      border: 1px dashed #8998a0;
      color: #8998a0;
    }
  }
  .el-table {
    border: 1px solid #ebeef5;
    border-bottom: none;
    img {
      height: 90px;
      width: 90px;
      border-radius: 4px;
    }
    span {
      color: #8998a0;
    }
    .table-inner-info {
      margin-left: 16px;
      flex: 1;
      & > span {
        color: #040b28;
        line-height: 20px;
        margin-bottom: 6px;
      }
      & > p {
        line-height: 20px;
      }
    }
  }
}
</style>
